<template>
  <div class="license-exceeded-state">
    <div class="empty">
      <div class="empty-icon">
        <fa-icon :icon="['fal', 'exclamation-triangle']" size="3x"></fa-icon>
      </div>
      <p class="empty-title h5">Você atingiu o limite de licenças</p>
      <p class="empty-subtitle" v-if="canManageAccount">
        Todas as licenças do seu plano estão em uso neste momento.
        <br>
        Para que ninguém da equipe fique de fora, clique em
        <strong>Contratar mais licenças</strong>.
        <br>
        <span class="text-info">
          Se preferir, desconecte um usuário para liberar um acesso agora.
        </span>
      </p>
      <p class="empty-subtitle" v-else>
        Todas as licenças do plano estão em uso neste momento.
        <br>
        Para que ninguém da equipe fique de fora, peça ao responsável pelo
        estabelecimento para contratar mais licenças.
        <br>
        <span class="text-info">
          Seu acesso é liberado automaticamente assim que alguém sair do sistema.
        </span>
      </p>
      <div class="empty-action">
        <router-link
          v-if="canManageAccount"
          class="btn btn-primary btn-icon btn-icon-left mr-2"
          to="/customer/licenses"
        >
          <fa-icon :icon="['fal', 'plus']"/>Contratar mais licenças
        </router-link>
        <button
          v-if="canManageAccount"
          class="btn btn-secondary btn-icon btn-icon-left mr-2"
          @click="modalShow = true"
        >
          <fa-icon :icon="['fal', 'users']"/>Ver usuários conectados
        </button>
        <router-link class="btn btn-neutral btn-icon btn-icon-left" to="/logout">
          <fa-icon :icon="['fal', 'sign-out-alt']"/>Sair do sistema
        </router-link>
      </div>
    </div>

    <license-sessions-modal
      v-if="modalShow"
      :show="modalShow"
      @close="modalShow = false"
    />
  </div>
</template>

<script>
import { MANAGE_CUSTOMER_ACCOUNT } from '@/data/actions/modules/general';
import LicenseSessionsModal from './LicenseSessionsModal.vue';

const POLLING_INTERVAL = 30000;

export default {
  name: 'LicenseExceededState',
  components: {
    LicenseSessionsModal,
  },
  data() {
    return {
      modalShow: false,
      pollingId: null,
    };
  },
  computed: {
    canManageAccount() {
      return this.$can(MANAGE_CUSTOMER_ACCOUNT);
    },
  },
  mounted() {
    // A API não emite evento quando uma licença libera. Consulta /me periodicamente e,
    // assim que a sessão for aceita, restaura o usuário e sai desta tela.
    this.pollingId = setInterval(this.checkAccess, POLLING_INTERVAL);
  },
  beforeDestroy() {
    clearInterval(this.pollingId);
  },
  methods: {
    async checkAccess() {
      try {
        const { data } = await this.$httpX.get('/me');
        if (data.licenseExceeded === false) {
          await this.$store.dispatch('setUser', data);
        }
      } catch (e) {
        // Mantém a tela e tenta de novo no próximo ciclo.
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";

.license-exceeded-state {
  margin: 0 auto;
  max-width: $control-width-lg;
  .empty {
    background-color: $light-color;
    border: $border-width solid $border-color;
  }
  .empty-icon {
    svg {
      color: $warning-color;
    }
  }
}
</style>
